import HeaderLogoWhite from './logo/HeaderLogoWhite'
import './style.scss'

function HeaderSolid() {

	return (
		<div className="header-solid-wrap">
			<div className='header-top-wrap'>
				<HeaderLogoWhite />
			</div>
		</div>
	)
}

export default HeaderSolid